export const mainRouteMapping: {
  [slug: string]: { id: number; name: string };
} = {
  'koh-phi-phi': { id: 1, name: 'Koh Phi Phi' },
  lembeh: { id: 2, name: 'Lembeh' },
  komodo: { id: 3, name: 'Komodo' },
  'deep-south': { id: 5, name: 'Deep South' },
  'banda-sea': { id: 6, name: 'Banda Sea' },
  halmahera: { id: 4, name: 'Halmahera' },
  'south-andaman': { id: 7, name: 'South Andaman' },
  'north-andaman': { id: 8, name: 'North Andaman' },
  'koh-losin': { id: 9, name: 'Koh Losin' },
  'classic-maldives': { id: 10, name: 'Classic Maldives' },
  palau: { id: 11, name: 'Palau' },
  'triton-bay': { id: 12, name: 'Triton Bay' },
  sulawesi: { id: 13, name: 'Sulawesi' },
  bali: { id: 14, name: 'Bali' },
  'raja-ampat': { id: 15, name: 'Raja Ampat' },
  flores: { id: 16, name: 'Flores' },
  sumbawa: { id: 17, name: 'Sumbawa' },
  'central-atolls': { id: 18, name: 'Central Atolls' },
  'southern-atolls': { id: 19, name: 'Southern Atolls' },
  'northern-atolls': { id: 20, name: 'Northern Atolls' },
  'koh-tao': { id: 22, name: 'Koh Tao' },
  'sea-of-cortez': { id: 23, name: 'Sea of Cortez' },
  'magdalena-bay': { id: 24, name: 'Magdalena Bay' },
  alor: { id: 25, name: 'Alor' },
};
